/* Roadmap swim-lanes (designs/intake-ui-parity.md UP5): rows grouped by
   their effective phase — the admin's roadmap phase when set, otherwise the
   submitter's target. Ported from the prototype verbatim. */
import type { JSX } from "react";
import { PHASE_TARGETS, PRIORITIES, labelFor } from "../../../shared/capabilities";
import { effectivePhase, isShared, type BoardView } from "./board-view";

const LANES = [...PHASE_TARGETS, { value: "__none", label: "Unplanned" }];

export function RoadmapView({
  rows,
  onOpen,
}: {
  rows: BoardView[];
  onOpen: (id: string) => void;
}): JSX.Element {
  const byLane = new Map<string, BoardView[]>(LANES.map((l) => [l.value, []]));
  for (const r of rows) {
    /* no phase recorded anywhere reads as Unplanned — not as a guessed gate */
    const phase = effectivePhase(r) ?? "__none";
    byLane.get(byLane.has(phase) ? phase : "__none")!.push(r);
  }
  return (
    <div className="roadmap" data-intake-roadmap>
      {LANES.map((lane) => {
        const items = byLane.get(lane.value)!;
        return (
          <div key={lane.value} className="lane">
            <div className="lane-head">
              <span>{lane.label}</span>
              <span className="lane-count">{items.length}</span>
            </div>
            <div className="lane-body">
              {items.length === 0 ? (
                <div className="lane-empty">—</div>
              ) : (
                items.map((r) => (
                  <button key={r.id} className="rmcard" onClick={() => onOpen(r.id)}>
                    <div className="rmcard-top">
                      {isShared(r) && <span className="tinytag shared">shared</span>}
                    </div>
                    <div className="rmcard-name">{r.name}</div>
                    <div className="rmcard-meta">
                      {r.teamName} · {labelFor(PRIORITIES, r.priority)}
                    </div>
                    {(r.tracking?.plannedStart != null || r.tracking?.plannedEnd != null) && (
                      <div className="rmcard-dates">
                        {r.tracking.plannedStart ?? "…"} → {r.tracking.plannedEnd ?? "…"}
                      </div>
                    )}
                  </button>
                ))
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
